<template>
  <div>
    <div class="mb-2">
      <h2>{{ $t("delegationOrder.decision.summary") }}</h2>
    </div>
    <div>
      <strong>{{ $t("delegationOrder.decision.status") }}:</strong>
      <delegation-order-status-chip :status="delegationDecision.status" />
    </div>
    <div v-if="$store.state.Auth.userProperties == null || $store.state.Auth.userProperties.system_settings.cost_centre_on_delegations !== 3">
      <strong>{{ $t("delegationOrder.decision.costCentre") }}: </strong>
      {{ delegationDecision.cost_centre == null ? $t("global.notSet") : delegationDecision.cost_centre.name }}
    </div>
    <div>
      <strong>{{ $t("delegationOrder.decision.delegated") }}: </strong>{{ delegationDecision.user_name }} ({{ delegationDecision.user_login }})
    </div>
    <div>
      <strong>{{ $t("delegationOrder.decision.destination") }}:</strong>
      {{ delegationDecision.destinationText }}
    </div>
    <div>
      <strong>{{ $t("delegationOrder.decision.task") }}:</strong>
      {{ $i18n.locale === "pl" || delegationDecision.task_name_en == null ? delegationDecision.task_name : delegationDecision.task_name_en }}
    </div>
    <div v-if="delegationDecision.task != null && delegationDecision.task.length > 0">
      <strong>{{ $t("delegationOrder.decision.taskDescription") }}:</strong>
      {{ delegationDecision.task }}
    </div>
    <div>
      <strong>{{ $t("delegationOrder.decision.startDate") }}:</strong>
      {{ formatDate(delegationDecision.start_date) }}
    </div>
    <div>
      <strong>{{ $t("delegationOrder.decision.endDate") }}:</strong>
      {{ formatDate(delegationDecision.end_date) }}
    </div>

    <div v-if="delegationDecision.external_customer_name != null && delegationDecision.external_customer_name.length > 0">
      <strong>{{ $t("delegation.form.fields.externalCustomer.name") }}:</strong>
      {{ delegationDecision.external_customer_name }}
    </div>
    <div v-if="delegationDecision.project_name != null && delegationDecision.project_name.length > 0">
      <strong>{{ $t("delegation.form.fields.project.name") }}:</strong>
      {{ delegationDecision.project_name }}
    </div>

    <delegation-order-restrictions
      :allowed-transport-cost-model.sync="delegationDecision.allowed_transport_cost"
      :allowed-transport-model.sync="delegationDecision.allowed_transport"
    >
    </delegation-order-restrictions>
    <collapse-simple-advance-panel :model-advances.sync="delegationDecision.advances" :addable="false" />

    <v-btn :disabled="$store.getters['Ajax/loading']" @click="downloadSettlement" class="primary ma-3">{{
      $t("delegationOrder.decision.downloadStatement")
    }}</v-btn>
    <v-btn class="primary" :to="'/delegation-order/readonly/' + delegationDecision.id">{{ $t("delegationOrder.viewReadonly") }}</v-btn>

    <h2>{{ $t("delegationOrder.decision.acceptanceHistory") }}</h2>

    <div>
      {{ $t("delegationOrder.decision.created") }} {{ $t("global.at") }} {{ delegationDecision.created_at }} {{ $t("global.by") }}
      {{ delegationDecision.created_by_name }}
      ({{ delegationDecision.created_by_login }}).
    </div>
    <!-- eslint-disable-next-line -->
    <span v-for="historyItem in delegationDecision.history">{{ historyItem }} <br /></span>

    <div v-if="delegationDecision.hasPermissionForSubstantialDecision && delegationDecision.status === 2">
      <h2>
        {{ $t("delegationOrder.decision.hasPermissionForSubstantialDecision") }}
      </h2>
      <v-row class="text-center">
        <v-spacer />
        <!--                <v-flex class="choose-box elevation-5 " md4 vertical-align xs12 :class="{'border-positive': delegationDecision.accepted_by_id!=null}">-->
        <v-col class="choose-box elevation-5  vertical-align" md="4" cols="12">
          <h3>{{ $t("delegationOrder.decision.positive.title") }}</h3>
          <v-icon size="75px">fa-check</v-icon>
          <p>
            {{
              delegationDecision.accepted_by_id == null
                ? $t("delegationOrder.decision.positive.description.substantial")
                : $t("delegationOrder.decision.positive.description.substantialAlready")
            }}
          </p>
          <br /><br />
          <v-btn :disabled="$store.getters['Ajax/loading']" bottom @click="accept()">{{ $t("delegationOrder.decision.positive.acceptButton") }}</v-btn>
        </v-col>
        <v-spacer />
        <!--                <v-flex class="choose-box elevation-5" md4 xs12 :class="{'border-negative': delegationDecision.rejected_at!=null}">-->
        <v-col class="choose-box elevation-5" md="4" cols="12">
          <h3>{{ $t("delegationOrder.decision.negative.title") }}</h3>
          <v-icon size="75px">fa-ban</v-icon>
          <p>
            {{ $t("delegationOrder.decision.negative.description.substantial") }}
          </p>
          <br />
          <v-btn :disabled="$store.getters['Ajax/loading']" bottom @click="deny()" class="ma-3">{{ $t("delegationOrder.decision.negative.denyButton") }}</v-btn>
          <v-btn :disabled="$store.getters['Ajax/loading']" bottom @click="denyAndRevert()" class="ma-3">{{
            $t("delegationOrder.decision.negative.denyAndRevertButton")
          }}</v-btn>
        </v-col>
        <v-spacer />
      </v-row>
    </div>
  </div>
</template>

<script>
import DelegationOrderRestrictions from "./DelegationOrderRestrictions";
import CollapseSimpleAdvancePanel from "../Advance/CollapseSimpleAdvancePanel";
import DelegationOrderStatusChip from "./DelegationOrderStatusChip";
export default {
  name: "DelegationOrderDecisionForm",
  components: {
    DelegationOrderStatusChip,
    CollapseSimpleAdvancePanel,
    DelegationOrderRestrictions
  },
  props: {
    delegationDecision: {
      required: true
    }
  },
  computed: {
    contextDelegationDecision: {
      get() {
        return this.delegationDecision;
      },
      set(value) {
        this.$emit("update:delegationDecision", value);
      }
    }
  },
  watch: {},
  methods: {
    formatDate(dateTime) {
      if (dateTime != null && dateTime.length > 0) {
        return dateTime.substr(dateTime.length - 8) === "00:00:00" ? dateTime.substr(0, dateTime.length - 8) : dateTime;
      }
      return "";
    },
    downloadSettlement() {
      this.$emit("downloadSettlement");
    },
    accept() {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("components.actions.delegation.acceptConfirm.content"),
        title: this.$t("components.actions.delegation.acceptConfirm.title")
      });
      result.then(() => {
        this.$emit("accept");
      });
    },
    deny() {
      let result = this.$store.dispatch("promptDialog", {
        content: this.$t("components.actions.delegationOrder.rejectConfirm.content"),
        title: this.$t("components.actions.delegationOrder.rejectConfirm.title"),
        label: this.$t("delegationOrder.decision.reason"),
        //rules: [/*v=>(v!=null&&v.length>0)||'Pole wymagane'*/],
        textarea: true
      });
      result.then(promptText => {
        this.$emit("deny", promptText);
      });
    },
    denyAndRevert() {
      let result = this.$store.dispatch("promptDialog", {
        content: this.$t("components.actions.delegationOrder.rejectAndBackConfirm.content"),
        title: this.$t("components.actions.delegationOrder.rejectAndBackConfirm.title"),
        label: this.$t("delegationOrder.decision.reason"),
        rules: [
          /*v=>(v!=null&&v.length>0)||'Pole wymagane'*/
        ],
        textarea: true
      });
      result.then(promptText => {
        this.$emit("denyAndRevert", promptText);
      });
    }
  }
};
</script>

<style scoped></style>
